/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wizard_Step_DocsInputs */

const en_wizard_step_docs = /** @type {(inputs: Wizard_Step_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation`)
};

const id_wizard_step_docs = /** @type {(inputs: Wizard_Step_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasi`)
};

/**
* | output |
* | --- |
* | "Documentation" |
*
* @param {Wizard_Step_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const wizard_step_docs = /** @type {((inputs?: Wizard_Step_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wizard_Step_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_wizard_step_docs(inputs)
	return en_wizard_step_docs(inputs)
});